import { FsMatchTrack } from "db/model/match/Track/FsMatchTrack";
import { MatchTrackBase } from "model/Match/Track/MatchTrack";

export const mapMatchTrackBase = (fsModel: FsMatchTrack): MatchTrackBase => {
  return {
    isComplete: fsModel.overrideComplete ?? false,
    trackId: fsModel.trackId,
  };
};
